/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";

/* Component Imports */

import { Typography, Paper } from "@material-ui/core";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  resultsRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    margin: "2rem 0rem 1rem 0rem",
    gap: "1rem",
    [theme.breakpoints.down("xs")]: {
      margin: "3rem 0rem 0.5rem 0rem",
    },
  },
  paper: {
    padding: "0.8rem",
    width: "8rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "space-between",
    justifyContent: "flex-start",
    background: "linear-gradient(90deg, #F74134 0%, #EB1C61 100%)",
  },
  resultHeading: {
    color: "#FFFFFF",
    fontWeight: "400",
    fontSize: "0.75rem",
    lineHeight: "1rem",
    margin: "0rem 0rem 0.5rem 0rem",
  },
  resultValue: {
    color: "#FFFFFF",
    fontWeight: "400",
    fontSize: "1rem",
    lineHeight: "1rem",
  },
}));

const EMIResults = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <div className={classes.resultsRow}>
          {/* EMI */}
          <Paper elevation={2} className={classes.paper}>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultHeading}
            >
              Monthly EMI
            </Typography>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultValue}
            >
              ₹ {props.emi}
            </Typography>
          </Paper>

          {/* Tenure */}
          <Paper elevation={2} className={classes.paper}>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultHeading}
            >
              Tenure (months)
            </Typography>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultValue}
            >
              {props.tenure * 12} Months
            </Typography>
          </Paper>

          {/* Interest Rate*/}
          <Paper elevation={2} className={classes.paper}>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultHeading}
            >
              Rate of interest
            </Typography>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultValue}
            >
              {props.interestRate}%
            </Typography>
          </Paper>

          {/* Total Interest */}
          <Paper elevation={2} className={classes.paper}>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultHeading}
            >
              Total Interest
            </Typography>
            <Typography
              variant="body2"
              component="p"
              className={classes.resultValue}
            >
              ₹ {props.totalInterest}
            </Typography>
          </Paper>
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className={classes.resultsRow}>
          {/* EMI */}
          <Skeleton>
            <Paper elevation={2} className={classes.paper}>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultHeading}
              >
                Monthly EMI
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultValue}
              >
                ₹ {props.emi}
              </Typography>
            </Paper>
          </Skeleton>

          {/* Tenure */}
          <Skeleton>
            <Paper elevation={2} className={classes.paper}>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultHeading}
              >
                Tenure (months)
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultValue}
              >
                {props.tenure * 12} Months
              </Typography>
            </Paper>
          </Skeleton>

          {/* Interest Rate*/}
          <Skeleton>
            <Paper elevation={2} className={classes.paper}>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultHeading}
              >
                Rate of interest
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultValue}
              >
                {props.interestRate}%
              </Typography>
            </Paper>
          </Skeleton>

          {/* Total Interest */}
          <Skeleton>
            <Paper elevation={2} className={classes.paper}>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultHeading}
              >
                Total Interest
              </Typography>
              <Typography
                variant="body2"
                component="p"
                className={classes.resultValue}
              >
                ₹ {props.totalInterest}
              </Typography>
            </Paper>
          </Skeleton>
        </div>
      </React.Fragment>
    );
  }
};

export default EMIResults;
